import { render } from "./copy-form.vue?vue&type=template&id=f29c19fe&scoped=true"
import script from "./copy-form.vue?vue&type=script&lang=js"
export * from "./copy-form.vue?vue&type=script&lang=js"

import "./copy-form.vue?vue&type=style&index=0&id=f29c19fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f29c19fe"]])

export default __exports__